// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cald_back_next-seperator {
  color: #b5b3b3;
  display: inline-block;
  transform: rotate(0deg) translate(0%);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/navigate-wizard/navigate-wizard.component.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,qBAAA;EACA,qCAAA;AAAJ","sourcesContent":["\n.cald_back_next-seperator{\n    color: #b5b3b3;\n    display: inline-block;\n    transform: rotate(0deg) translate(0%);\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
